import { render, staticRenderFns } from "./MoleculeContentBlocks.vue?vue&type=template&id=b34023ba&scoped=true&"
import script from "./MoleculeContentBlocks.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentBlocks.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentBlocks.vue?vue&type=style&index=0&id=b34023ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34023ba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingGuidedTourContentBlocksMoleculeContentBlockEmbed: require('/app/components/molecules/project/building/guidedTour/contentBlocks/MoleculeContentBlockEmbed.vue').default,MoleculesProjectBuildingGuidedTourContentBlocksMoleculeContentBlockIframe: require('/app/components/molecules/project/building/guidedTour/contentBlocks/MoleculeContentBlockIframe.vue').default,MoleculesProjectBuildingGuidedTourContentBlocksMoleculeContentBlockText: require('/app/components/molecules/project/building/guidedTour/contentBlocks/MoleculeContentBlockText.vue').default,MoleculesProjectBuildingGuidedTourContentBlocksMoleculeContentBlockVideo: require('/app/components/molecules/project/building/guidedTour/contentBlocks/MoleculeContentBlockVideo.vue').default,MoleculesProjectBuildingGuidedTourContentBlocksMoleculeContentBlockImage: require('/app/components/molecules/project/building/guidedTour/contentBlocks/MoleculeContentBlockImage.vue').default})
